import { required, confirmed, email } from "vee-validate/dist/rules";
import { extend } from "vee-validate";

const email_regex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const username_regex = /^[a-zA-Z0-9+-]+$/;

extend("required", {
    ...required,
    message: "ველის შევსება აუცილებელია",
});

extend("email", {
    ...email,
    message: "ფორმატი არასწორია",
});

extend("confirmed", {
    ...confirmed,
    message: "არ ემთხვევა პაროლი",
});

extend("min", {
    validate(value, args) {
        return value.length >= Number(args.min);
    },
    params: ["min"],
    message: "მინიმალური სიმბოლო {min}",
});

extend("max", {
    validate(value, args) {
        const res = value.length > Number(args.max);

        return !res;
    },
    params: ["max"],
    message: "მაქსიმალური სიმბოლო {max}",
});
extend("Nospace", {
    validate(value) {
        if (/^\S+$/g.test(value)) {
            return true;
        }
        return false;
    },
    params: ["Nospace"],
    message: "ფორმატი არავალიდურია",
});

extend("date", {
    validate(value) {
        let dt = value.split("/").reverse().join("-");

        return !isNaN(new Date(dt).getDate());
    },
    params: ["Date"],
    message: "თარიღი არავალიდურია",
});
extend("float", {
    validate(value) {
        let numbers = /^[+-]?((\.\d+)|(\d+(\.\d+)?))$/;

        if (value == 0) {
            return false;
        }
        return numbers.test(value);
    },
    params: ["float"],
    message: "ფორმატი არავალიდურია",
});

extend("decimal", {
    validate: (value, { decimals = "*", separator = "." } = {}) => {
        if (value === null || value === undefined || value === "") {
            return {
                valid: false,
            };
        }
        if (Number(decimals) === 0) {
            return {
                valid: /^-?\d*$/.test(value),
            };
        }
        const regexPart = decimals === "*" ? "+" : `{1,${decimals}}`;
        const regex = new RegExp(
            `^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`
        );

        return {
            valid: regex.test(value),
        };
    },
    message: "ფორმატი არავალიდურია",
});

extend("numeric", {
    validate(value) {
        if (isNaN(value)) {
            return false;
        }

        return true;
    },
    message: "ფორმატი არავალიდურია",
});
